import styled from 'styled-components';
import { colors, device } from '../../styles/stylesheets';

export const Container = styled.div`
  display: grid;
  min-height: 96px;
  padding: 20px;
  margin: 36px 0 16px;
  row-gap: 16px;
  background: ${colors.white};
  border: 1px solid ${colors.greyLighter};
  border-radius: 8px;
  @media ${device.fromLaptop} {
    grid-template-columns: 1fr 195px;
  }
  @media ${device.fromLaptop} {
    grid-template-areas: "date details" 
                         "title details"
                         "status stepper";
  }
  @media ${device.untilLaptop} {
    padding: 20px 16px;
    box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.05);
    grid-template-areas: "date details" 
                         "title title"
                         "status status";
  }
`;

export const ArrowHeader = styled.div`
  display: inline-block;
  border: 0px solid ${colors.primary};
  width: 12px;
  height: 12px;
  border-top-width: 2px;
  border-right-width: 2px;
  transform: ${({ show }) => (show ? 'rotate(135deg)' : 'rotate(45deg)')};
`;

export const TaskHeaderDate = styled.div`
  grid-area: date;
  font-size: 0.8rem;
  color: ${colors.greyMedium};
`;

export const TaskHeaderDetails = styled.span`
  grid-area: details;
  font-size: 0.8rem;
  line-height: 1rem;
  color: ${colors.primary};
  text-align: right;

  @media ${device.untilLaptop} {
    ::before{
      content: 'Detalhes';
    }
  }
  @media ${device.fromLaptop} {
    ::before{
      content: 'Detalhes do pedido';
    }
  }
`;

export const TaskTitle = styled.h3`
  grid-area: title;
  font-size: 1rem;
  line-height: 1.2rem;
  color: ${colors.primary};
  @media ${device.fromLaptop} {
    margin-bottom: 40px;
  }
`;

export const TaskStatus = styled.div`
  grid-column: max-content;
  grid-area: status;
`;

export const TaskStatusTitle = styled.h4`
  border-radius: 4px;
  padding: 0 0 12px;
  color: ${colors.blue};
  @media ${device.untilLaptop} {
    padding: 12px 16px;
    background-color: ${colors.alabaster2};
  }
`;

export const TaskStatusDescription = styled.p`
  font-size: 0.8rem;
  line-height: 1rem;
  font-weight: 400;
  padding-bottom: 20px;
`;

export const TaskQuotes = styled.div`
  background: rgba(238, 238, 238, 0.3);
  border-radius: 4px;
  padding: 16px;
`;

export const QuotesTitle = styled.h4`
`;

export const QuotesEmpty = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  color: ${colors.greyMedium};
  font-size: 12px;
  line-height: 16px;
  padding-top: 16px;
  > * {
    padding-bottom: 12px;
  }
`;

export const Quotes = styled.div`
  padding-top: 16px;
  @media ${device.untilLaptop} {
    overflow: auto;
    max-height: 100%;
  }
`;

export const TaskStepper = styled.div`
  grid-area: stepper;
  flex: 0;
  @media ${device.untilLaptop} {
    display: none;
  }
`;

export const TaskStepperTitle = styled.div`
  font-size: 0.8rem;
  color: ${colors.greyMedium};
  margin-bottom: 20px;
`;

export const TextButton = styled.button`
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  text-decoration: underline;
  font-size: inherit;
`;
